import {buildQueryString} from "../../../utils/url";
import "whatwg-fetch";
import { getTenantFromURL } from "../../components/common/MultiTenancy/MultiTenancyHelper";

class DownloaderApi {
    static downloadFile(path, queryParams = undefined, method){
        /**
         * Function that will fetch the file, once the file is built
         * by the API. Then a promise is resolved if the file is downloaded.
         */
        let fileResult = {};
        let extraData = [];
        let body;
        const tenantHeader = getTenantFromURL();
        const headers = {
            "tenant": tenantHeader
        };

        if(method == "GET"){
            path += buildQueryString(queryParams, path);
        }
        else{
            body = JSON.stringify(queryParams);
        }
        return new Promise ((resolve, failure) =>{
            
        fetch(path,{method, body, headers})
        .then((response => {    
            if(response.headers.get("content-type").toLowerCase() ===
            "application/json"){
                
                return response.json();
            }
            else{
                // AWS S3 Reponse
                return response.blob();
            }
        }))
        .then((result => {
            if(result.error && result.error.length > 0){
                let serverErrResults = {};
                serverErrResults.error = result.error;
                serverErrResults.message = result.message;
                serverErrResults.path = path;
                failure(serverErrResults);
                throw new Error("File download error");
            }
            if(result.extraData){
                let errorResults = {};
                errorResults.extraData = result.extraData;
                
                errorResults.path = path;
                if(result.extraData.errorCode || !result.fileContent){
                    failure(errorResults);
                    throw new Error("File download error");
                }
            }
            if(extraData.length > 0){
                fileResult.extraData = extraData;
            }
            fileResult.result = result;
            
            fileResult.path = path;
            fileResult.extraData = result.extraData;
        }))
        .then(()=>{
            resolve(fileResult);

        });       
        });
        
    }
}

export default DownloaderApi;




// WEBPACK FOOTER //
// ./src/utils/downloader/downloaderApi.js